import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";
import { paginationSelectSx } from "../../StoryList/StoryListContent/StoryListTablePagination.styles";

export const styles = createTypedSxStyles({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    borderRadius: "8px",
    overflow: "hidden",
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
  },
  tableWrapper: {
    overflowY: "auto",
  },
  pagination: {
    borderTop: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    position: "sticky",
    bottom: 0,
    backgroundColor: capitalDesignTokens.semanticColors.background.primary,
    zIndex: 1,
    ...paginationSelectSx,
  },
  tableHead: {
    "& .MuiTableCell-head": {
      backgroundColor: capitalDesignTokens.semanticColors.background.secondary,
      color: capitalDesignTokens.semanticColors.foreground.primary,
      fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
      borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
      paddingTop: "12px",
      paddingBottom: "12px",
    },
  },
  tableRow: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: capitalDesignTokens.semanticColors.background.secondary,
    },
    "&:focus-visible": {
      outline: `2px solid ${capitalDesignTokens.semanticColors.foreground.action}`,
      outlineOffset: "-2px",
    },
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
      paddingTop: "0px",
      paddingBottom: "0px",
      height: "80px",
    },
  },
  publicationNameWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  thumbnail: {
    width: "80px",
    height: "56px",
    objectFit: "cover",
    borderRadius: "4px",
    flexShrink: 0,
  },
  thumbnailPlaceholder: {
    width: "80px",
    height: "56px",
    borderRadius: "4px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: capitalDesignTokens.semanticColors.background.tertiary,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
  },
  createdByWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  avatar: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: capitalDesignTokens.semanticColors.background.actionLight,
    color: capitalDesignTokens.semanticColors.foreground.action,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    fontSize: "12px",
    flexShrink: 0,
  },
  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "64px 24px",
    gap: "16px",
    textAlign: "center",
  },
  spinner: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "64px",
  },
  cardGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
    gap: "16px",
    padding: "16px",
    overflowY: "auto",
  },
  card: {
    cursor: "pointer",
    borderRadius: "8px",
    overflow: "hidden",
    border: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    "&:hover": {
      boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
    },
    "&:focus-visible": {
      outline: `2px solid ${capitalDesignTokens.semanticColors.foreground.action}`,
      outlineOffset: "2px",
    },
  },
  cardImage: {
    width: "100%",
    height: "140px",
    objectFit: "cover",
  },
  cardImagePlaceholder: {
    width: "100%",
    height: "140px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: capitalDesignTokens.semanticColors.background.tertiary,
    color: capitalDesignTokens.semanticColors.foreground.secondary,
  },
  cardContent: {
    padding: "12px",
  },
});
